import React from 'react';
import { TripMatchStatus, TripMatchStatusInfo } from '@marageti/z4-sdk/lib/travel';
import {
  CanceledByTravelerAlert, MatchErrorAlert, CanceledByZicassoAlert, CanceledByPartnerAlert, BookingCanceledAlert, BookingRefundedAlert,
} from '../../../components/trip-match-alerts';

const Alerts = ({ status, statusInfo }: { status: TripMatchStatus, statusInfo: TripMatchStatusInfo }) => {
  switch (status) {
    case TripMatchStatus.MatchTravelerCanceled:
      return <CanceledByTravelerAlert statusInfo={statusInfo} />;
    case TripMatchStatus.MatchZicassoMatchError:
      return <MatchErrorAlert statusInfo={statusInfo} />;
    case TripMatchStatus.MatchZicassoCanceled:
      return <CanceledByZicassoAlert statusInfo={statusInfo} />;
    case TripMatchStatus.MatchPartnerCanceled:
      return <CanceledByPartnerAlert statusInfo={statusInfo} />;
    case TripMatchStatus.MatchSoldCanceled:
      return <BookingCanceledAlert statusInfo={statusInfo} />;
    case TripMatchStatus.MatchRefundedCanceled:
      return <BookingRefundedAlert statusInfo={statusInfo} />;
    // Add cases for other types of alerts here
    default:
      return null; // Return null for statuses that don't require an alert
  }
};

export default Alerts;
